export default __webpack_public_path__ + "static/media/search-icon.5c6bf969.svg";